import { render } from "./SampleCardSix.vue?vue&type=template&id=54dc3c86"
import script from "./SampleCardSix.vue?vue&type=script&lang=js"
export * from "./SampleCardSix.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__